import { render, staticRenderFns } from "./BuyerReferences.vue?vue&type=template&id=bbe9d318"
import script from "./BuyerReferences.vue?vue&type=script&lang=js"
export * from "./BuyerReferences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports